import { jsx as _jsx } from "react/jsx-runtime";
import { useConsent } from './ConsentContext.js';
export function CookieSettingsLink({ dialogId, label = 'Cookie settings', children, ...props }) {
    const ctx = useConsent();
    const resolvedId = dialogId ?? ctx.dialogId ?? 'cmp-dialog';
    const open = () => document.getElementById(resolvedId)?.showModal();
    return (_jsx("button", { type: "button", onClick: open, ...props, children: children ?? label }));
}
//# sourceMappingURL=CookieSettingsLink.js.map